<template>
  <!--弹框4 开始-->
  <div class="dia-info">
    <el-dialog :visible.sync="frameRiseDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center style="text-align: center;">
      <div style="width:100%;text-align: center; margin-top: 10px;">
        <div style="height: 120px;"><img src="/static/img/frame/rise.png" class="frame-small-img" @click="refresh"></div>
        <div class="frame-text-rise" style="width: 90%;margin: 0 auto;">
          <div class="wordBreak">Attention! The prices for your selected dates have been updated, with an additional <span style="font-weight: 500;color: #E12D2D;">{{common.currencySet()}} {{risePrice}}</span>. Kindly review the new rates before confirming your reservation. Thank you for your understanding.</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="white_button" style="width: auto;" @click="goback">{{$t('back')}}</el-button>
        <el-button type="primary" class="booknow_button" style="margin-left: 15px; width: auto; float: none;" @click="writeOrderFun">Continue</el-button>
      </span>
    </el-dialog>
  </div>
  <!--弹框4 结束-->
  <!--引入方式-->
  <!-- <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice"></frameRise> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
import { updateVerifyPrice } from '@/request/order.js'
export default {
  name: 'frameRise',
  props: ['frameRiseDialog', 'risePrice', 'curPageData'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      pageRefresh: 0,
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: ''
    }
  },
  created () {
    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }

    if (window.performance.navigation.type === 1) {
      // console.log('页面被刷新')
      this.pageRefresh = 1
    }
  },
  methods: {
    refresh () {
      location.reload()
      this.frameRiseDialog = false
    },
    reserve () {
      this.frameRiseDialog = false
    },
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.$route.query
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.$route.query.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
      })
    },
    goback: function () {
      var paysubmitInfo = {'click': 1}
      this.$emit('frameRiseBookingBackFun', paysubmitInfo)
    },
    writeOrderFun: function () {
      let locationHref = window.document.location.href
      var that = this

      var paysubmitInfo = {}
      // 客人同意涨价信息，修改验价价格
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var productJson = sessionStorage.getItem('productStr')
      var product = JSON.parse(productJson)
      product.totalprice = parseInt(product.totalprice) + parseInt(this.risePrice)
      sessionStorage.setItem('productStr', JSON.stringify(product))

      var currency = this.common.currencySet(this)
      // 如果是酒店详情页 点下单
      var query = this.$route.query
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.$route.query.hotelid
        this.adult = parseInt(this.$route.query.adult)
        this.child = parseInt(this.$route.query.child)
        this.room = isNaN(parseInt(this.$route.query.room)) ? 1 : parseInt(this.$route.query.room)
        this.startdate = this.$route.query.start_date
        this.enddate = this.$route.query.end_date
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.checkin
        this.enddate = params.checkout
      }

      var Sparams = this.$route.params
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(Sparams) === '{}' && searchData !== '{}') {
        Sparams = JSON.parse(searchData)
      }
      var sessionid = this.common.sessionidGet(this)

      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      // var childNums = []
      // if (Sparams !== null && JSON.stringify(Sparams.childNums) !== '{}') {
      //   childNums = Sparams.childNums
      // }
      var seleteds = ''
      var childNums = this.$route.query.childNums
      if (this.child !== undefined && this.child !== null && this.child !== '' && this.child > 0 && !isNaN(this.child)) {
        seleteds = childNums
      }

      var productStr = sessionStorage.getItem('productStr')

      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {
        'hotelid': this.hotelid,
        'product': productStr,
        'token': token,
        'room': this.room,
        'adult': this.adult,
        'child': this.child,
        'childNums': seleteds,
        'checkin': this.startdate,
        'checkout': this.enddate,
        'currency': currency,
        'sessionid': sessionid,
        'roompaiToken': roompaiToken,
        'operation': 'updateVerifyPrice',
        'time': time
      }
      var data = this.common.encryptionData(dataJson, this)
      updateVerifyPrice(data).then(res => {
        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          that.$router.push({name: 'login'})
        } if (res.flag === '156') {
          // 关闭弹矿 重试
          paysubmitInfo = {'click': 1}
          this.$emit('frameRiseBookingBackFun', paysubmitInfo)
        } else if (res.flag === '200') {
          if (that.curPageData === 'HotelDetail') {
            var orderDataR = {
              'hotelid': that.hotelid,
              'product': productStr,
              'checkin': that.startdate,
              'checkout': that.enddate,
              'room': that.room,
              'adult': that.adult,
              'child': that.child,
              'childNums': childNums
            }
            localStorage.setItem('orderData', JSON.stringify(orderDataR))
            that.$router.push({name: 'WriteOrder', params: orderDataR})
          } else if (that.curPageData === 'WriteOrder') {
            var submitInfo = {'click': 1}
            that.$emit('frameRiseBookingFun', submitInfo)
          } else if (that.curPageData === 'WritePay') {
            paysubmitInfo = {'click': 1}
            that.$emit('frameRiseBookingFun', paysubmitInfo)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.frame-small-img{width:80px; height:80px;cursor: pointer;}
.frame-text-rise{height:90px; line-height: 22px;font-size: 13px;color: #4F4C4C;text-align: left; margin-top: 10px;}
.el-button+.el-button{margin-left:auto;}
/deep/ .el-dialog--center .el-dialog__body{padding: 10px 25px 30px !important;}
.dia-info /deep/ .el-dialog__header{padding: 0;}
</style>



// WEBPACK FOOTER //
// src/components/public/frameRise.vue